import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormulaCatalogoGrupoStruct } from '@shared/services/structs/formula/formula-catalogo-grupo.struct';
import { FormulaCardComponent } from '../formula-card/formula-card.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { quantidadeFormulasContexto, possuiFormulasContexto } from '../utils/formula-contexto.util';
import { FORMULA_BADGE_CLASSES } from '../utils/formula-badge.util';
import { modeloAtivo } from '../utils/formula-modelo.util';
import { FormulaCatalogoItemStruct } from '@shared/services/structs/formula/formula-catalogo-item.struct';
import { FormulaModeloStruct } from '@shared/services/structs/formula/formula-modelo.struct';
import { FormulaCardModoEnum } from '@shared/enums/motor-fiscal/formula-card-modo.enum';

@Component({
  selector: 'app-formula-grupo',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, FormulaCardComponent],
  templateUrl: './formula-grupo.component.html',
  styleUrl: './formula-grupo.component.css',
})
export class FormulaGrupoComponent {
  public readonly badgeClasses = FORMULA_BADGE_CLASSES;
  public readonly modoListagem = FormulaCardModoEnum.Listagem;
  @Input({ required: true }) grupo!: FormulaCatalogoGrupoStruct;
  @Input() permitirAlteracaoModeloEmpresa = false;
  @Output() modeloEmpresaSelecionado = new EventEmitter<{ chaveFormula: string; chaveFormulaModelo: string }>();

  public selecionarModeloEmpresa(formula: FormulaCatalogoItemStruct, modelo: FormulaModeloStruct): void {
    this.modeloEmpresaSelecionado.emit({
      chaveFormula: formula.chaveFormula,
      chaveFormulaModelo: modelo.chaveFormulaModelo,
    });
  }

  public quantidadeFormulas(grupo: FormulaCatalogoGrupoStruct): number {
    return quantidadeFormulasContexto(grupo);
  }

  public filhosComFormulas(grupo: FormulaCatalogoGrupoStruct): FormulaCatalogoGrupoStruct[] {
    return grupo.filhos.filter(possuiFormulasContexto);
  }

  public versoesFormula(formula: FormulaCatalogoItemStruct): FormulaModeloStruct[] {
    const atual = modeloAtivo(formula);
    if (!atual) return [];
    return (formula.modelos ?? [])
      .filter(modelo => modelo.chaveFormulaModelo === atual.chaveFormulaModelo)
      .sort((a, b) => (a.dataVigenciaInicio ?? '').localeCompare(b.dataVigenciaInicio ?? ''));
  }

  public versaoEhAtual(formula: FormulaCatalogoItemStruct, modelo: FormulaModeloStruct): boolean {
    const atual = modeloAtivo(formula);
    return !!atual
      && atual.chaveFormulaModelo === modelo.chaveFormulaModelo
      && atual.dataVigenciaInicio === modelo.dataVigenciaInicio
      && atual.dataVigenciaFim === modelo.dataVigenciaFim;
  }
}
